// Controls
import studioGear_mob from '../images/photos/studio-gear_800.jpg'
import studioGear from '../images/photos/studio-gear_1600.jpg'
import minifenk_mob from '../images/photos/minifenk_800.jpg'
import minifenk from '../images/photos/minifenk_1600.jpg'
import focal_mob from '../images/photos/focal-cms-65_800.jpg'
import focal from '../images/photos/focal-cms-65_1600.jpg'
import headphoneAmp_mob from '../images/photos/headphone-amp_800.jpg'
import headphoneAmp from '../images/photos/headphone-amp_1600.jpg'
import headphoneAmps_mob from '../images/photos/headphone-amps_800.jpg'
import headphoneAmps from '../images/photos/headphone-amps_1600.jpg'

// Studio
import mixSpace_mob from '../images/photos/mix-space_800.jpg'
import mixSpace from '../images/photos/mix-space_1600.jpg'
import liveSpace_mob from '../images/photos/live-space_800.jpg'
import liveSpace from '../images/photos/live-space_1600.jpg'
import theRoom_mob from '../images/photos/the-room_800.jpg'
import theRoom from '../images/photos/the-room_1600.jpg'
import deck_mob from '../images/photos/outside-deck_800.jpg'
import deck from '../images/photos/outside-deck_1600.jpg'
import pirongia_mob from '../images/photos/mount-pirongia_800.jpg'
import pirongia from '../images/photos/mount-pirongia_1600.jpg'

// Outboard
import fatLady_mob from '../images/photos/fat-lady_800.jpg'
import fatLady from '../images/photos/fat-lady_1600.jpg'
import urei_mob from '../images/photos/1176s_800.jpg'
import urei from '../images/photos/1176s_1600.jpg'
import ssl_mob from '../images/photos/ssl_800.jpg'
import ssl from '../images/photos/ssl_1600.jpg'
import commando_mob from '../images/photos/commando_800.jpg'
import commando from '../images/photos/commando_1600.jpg'
import neever_mob from '../images/photos/neever-twin_800.jpg'
import neever from '../images/photos/neever-twin_1600.jpg'
import germaniums_mob from '../images/photos/germaniums_800.jpg'
import germaniums from '../images/photos/germaniums_1600.jpg'
import roger_mob from '../images/photos/eq-one-roger_800.jpg'
import roger from '../images/photos/eq-one-roger_1600.jpg'
import eq_mob from '../images/photos/eq_800.jpg'
import eq from '../images/photos/eq_1600.jpg'
import memoryMan_mob from '../images/photos/memory-man_800.jpg'
import memoryMan from '../images/photos/memory-man_1600.jpg'
import reamping_mob from '../images/photos/reamping-unit_800.jpg'
import reamping from '../images/photos/reamping-unit_1600.jpg'

// Mics
import u47_mob from '../images/photos/u47_800.jpg'
import u47 from '../images/photos/u47_1600.jpg'
import tlm_mob from '../images/photos/102x2_800.jpg'
import tlm from '../images/photos/102x2_1600.jpg'
import se3_mob from '../images/photos/se3-pair_800.jpg'
import se3 from '../images/photos/se3-pair_1600.jpg'
import soundelux_mob from '../images/photos/u47-fet-clone_800.jpg'
import soundelux from '../images/photos/u47-fet-clone_1600.jpg'
import re320_mob from '../images/photos/ev-re320_800.jpg'
import re320 from '../images/photos/ev-re320_1600.jpg'
import mics_mob from '../images/photos/microphones_800.jpg'
import mics from '../images/photos/microphones_1600.jpg'
import cascade_mob from '../images/photos/cascade-fathead_800.jpg'
import cascade from '../images/photos/cascade-fathead_1600.jpg'

// Amps
import gunn_mob from '../images/photos/gunn-50_800.jpg'
import gunn from '../images/photos/gunn-50_1600.jpg'
import valveAmp_mob from '../images/photos/valve-amp_800.jpg'
import valveAmp from '../images/photos/valve-amp_1600.jpg'
import bassCube_mob from '../images/photos/bass-cube_800.jpg'
import bassCube from '../images/photos/bass-cube_1600.jpg'
import bassman_mob from '../images/photos/bassman-25_800.jpg'
import bassman from '../images/photos/bassman-25_1600.jpg'

// Instruments
import hayman_mob from '../images/photos/hayman-bass_800.jpg'
import hayman from '../images/photos/hayman-bass_1600.jpg'
import balalaika_mob from '../images/photos/balalaika-bass_800.jpg'
import balalaika from '../images/photos/balalaika-bass_1600.jpg'
import otherBasses_mob from '../images/photos/other-basses_800.jpg'
import otherBasses from '../images/photos/other-basses_1600.jpg'
import upright_mob from '../images/photos/upright-bass_800.jpg'
import upright from '../images/photos/upright-bass_1600.jpg'
import rogers_mob from '../images/photos/rogers-kit_800.jpg'
import rogers from '../images/photos/rogers-kit_1600.jpg'
import acoustics_mob from '../images/photos/acoustic-guitars_800.jpg'
import acoustics from '../images/photos/acoustic-guitars_1600.jpg'
import ibanezHalliday_mob from '../images/photos/ibanez-halliday_800.jpg'
import ibanezHalliday from '../images/photos/ibanez-halliday_1600.jpg'
import electrics_mob from '../images/photos/electric-guitars_800.jpg'
import electrics from '../images/photos/electric-guitars_1600.jpg'
import piano_mob from '../images/photos/piano_800.jpg'
import piano from '../images/photos/piano_1600.jpg'

export const gallery = [
  [
    'overview',
    {
      items: {
        hardware: {
          items: {
            converters: {
              alt: 'Studio Gear',
              caption: 'Mac Pro, Pro Tools 12, RME Converters, Avid 003',
              name: 'Computer & Converters',
              src: studioGear,
              srcMobile: studioGear_mob,
            },
          },
          name: 'Hardware',
        },
        monitoring: {
          items: {
            ekadekMinifenk: {
              alt: 'Monitor Controller',
              caption: 'Ekadek Minifenk Monitor Controller',
              name: 'Minifenk',
              src: minifenk,
              srcMobile: minifenk_mob,
            },
            focals: {
              alt: 'Monitors',
              caption: 'Focal CMS 65 Monitors',
              name: 'Focal CMS 65',
              src: focal,
              srcMobile: focal_mob,
            },
            headphoneamplifierrack: {
              alt: 'Headphone amp',
              caption: 'Handmade Headphone Amp',
              name: 'Headphone Amplifier Rack',
              src: headphoneAmp,
              srcMobile: headphoneAmp_mob,
            },
            headphoneamplifiers: {
              alt: 'Headphone amps',
              caption: 'Custom built headphone amplifiers',
              name: 'Headphone amplifiers',
              src: headphoneAmps,
              srcMobile: headphoneAmps_mob,
            },
          },
          name: 'Monitoring',
        },
        space: {
          items: {
            mixing: {
              alt: 'Mixing space',
              caption: 'Bagnall Hill cockpit',
              name: 'Mixing Space',
              src: mixSpace,
              srcMobile: mixSpace_mob,
            },
            performance: {
              alt: 'Live space',
              caption: 'View from the mixing desk',
              name: 'The Room (facing south)',
              src: liveSpace,
              srcMobile: liveSpace_mob,
            },
            performance2: {
              alt: 'Bagnall Hill Recording Studio',
              caption: 'Looking into Bagnall Hill Studio from the main entrance',
              name: 'The Room (facing north)',
              src: theRoom,
              srcMobile: theRoom_mob,
            },
            thedeck: {
              alt: 'Deck',
              caption: 'French doors open out from the live room onto an outdoor deck area',
              name: 'Outside Deck',
              src: deck,
              srcMobile: deck_mob,
            },
            viewofmtpirongia: {
              alt: 'Mt Pirongia',
              caption: 'You can catch a view of Mt Pirongia from outside the studio',
              name: 'View of Mt Pirongia',
              src: pirongia,
              srcMobile: pirongia_mob,
            },
          },
          name: 'The Space',
        },
      },
      order: 1,
    },
  ],
  [
    'outboard',
    {
      items: {
        compressors: {
          items: {
            fatlady: {
              alt: '2 channel compressor',
              caption: 'Two channel, 12 tube limiting amplifier',
              name: 'Ekadek Fat Lady',
              src: fatLady,
              srcMobile: fatLady_mob,
            },
            fet: {
              alt: '1176 clones',
              caption: 'A custom made pair of UREI 1176 compressor clones',
              name: '1176 Pair',
              src: urei,
              srcMobile: urei_mob,
            },
            ssl: {
              alt: 'SSL compressor',
              caption: 'Adds the glue',
              name: 'SSL Compressor Clone',
              src: ssl,
              srcMobile: ssl_mob,
            },
          },
          name: 'Compressors',
        },
        preamps: {
          items: {
            commando: {
              alt: '4 channel solid state preamp',
              caption: '4 channel solid state, simple and fat',
              name: 'Ekadek Commando',
              src: commando,
              srcMobile: commando_mob,
            },
            neever: {
              alt: 'Neever twin preamp',
              caption: 'Solid state preamps with real Neve boards inside',
              name: 'Ekadek Neever Twin',
              src: neever,
              srcMobile: neever_mob,
            },
            germaniums: {
              alt: 'Germanium preamps',
              caption: 'Comes complete with NICE/SHIT dial and HF boost',
              name: 'Ekadek Germanium Preamps',
              src: germaniums,
              srcMobile: germaniums_mob,
            },
            roger: {
              alt: 'Twin valve preamp and EQ',
              caption: 'Twin Pultec MB1 style valve preamps with valve EQ',
              name: 'Ekadek EQ One Roger',
              src: roger,
              srcMobile: roger_mob,
            },
          },
          name: 'Preamps',
        },
        various: {
          items: {
            ekadekeq: {
              alt: 'Ekadek EQ',
              caption: 'Hit the sweet spot',
              name: 'Ekadek EQ',
              src: eq,
              srcMobile: eq_mob,
            },
            memoryman: {
              alt: 'Memory Man and tremolo',
              caption:
                'Deluxe Memory Man stereo delay/chorus/vibrato clone and two channel tremolo',
              name: 'Memory Man and tremolo',
              src: memoryMan,
              srcMobile: memoryMan_mob,
            },
            'reamp unit': {
              alt: 'Reamp Unit',
              caption: 'Custom made, re-amp or add external effects to your audio signal',
              name: 'Reamp Unit',
              src: reamping,
              srcMobile: reamping_mob,
            },
          },
          name: 'Other',
        },
      },
      order: 2,
    },
  ],
  [
    'microphones',
    {
      items: {
        condensor: {
          items: {
            u47: {
              alt: 'U47 Replica',
              caption:
                'Stam Audio SA-47 tube condensor microphone. Described as an exact replica of the most revered vocal tube microphone in history, the Neumann U47',
              name: 'U47',
              src: u47,
              srcMobile: u47_mob,
            },
            condensor1: {
              alt: 'Neumann TLM Pair',
              caption: 'Great for vocals and acoustic instruments',
              name: 'Neumann TLM102 x 2',
              src: tlm,
              srcMobile: tlm_mob,
            },
            se3stereopair: {
              alt: 'Se3 Stereo Pair',
              caption: 'Small diaphragm condensor mics',
              name: 'sE3 Stereo Pair',
              src: se3,
              srcMobile: se3_mob,
            },
            u47fetclone: {
              alt: 'U47 FET Clone',
              caption: 'Vintage large diaphragm tone',
              name: 'Soundelux iFet7',
              src: soundelux,
              srcMobile: soundelux_mob,
            },
          },
          name: 'Condensor',
        },
        dynamic: {
          items: {
            'electro-voicere320': {
              alt: 'RE320',
              caption: 'Especially good for kick, bass cab and vocals',
              name: 'Electro-Voice RE320',
              src: re320,
              srcMobile: re320_mob,
            },
            'sm57x4,sm58x2,beta52a': {
              alt: 'Various Microphones',
              caption: 'Studio staples plus some extras',
              name: 'SM57 x 4, SM58 x 2, Beta52A',
              src: mics,
              srcMobile: mics_mob,
            },
          },
          name: 'Dynamic',
        },
        ribbon: {
          items: {
            ribbon1: {
              alt: 'Cascade Fathead',
              caption: 'With Lundahl transformer mod',
              name: 'Cascade Fat Head',
              src: cascade,
              srcMobile: cascade_mob,
            },
          },
          name: 'Ribbon',
        },
      },
      order: 3,
    },
  ],
  [
    'instruments',
    {
      items: {
        amplification: {
          items: {
            gunn: {
              alt: 'Gunn 50 Head',
              caption: 'NZ made vintage amp',
              name: 'Gunn 50 Head',
              src: gunn,
              srcMobile: gunn_mob,
            },
            handmadevalveamp: {
              alt: 'Valve Amp',
              caption: 'Boutique valve amp and matching cab, hand made in Te Pahu',
              name: 'Handmade Valve Amp',
              src: valveAmp,
              srcMobile: valveAmp_mob,
            },
            rolandbasscube: {
              alt: 'Roland Bass Cube',
              caption: 'Great for bass and keys',
              name: 'Roland Bass Cube',
              src: bassCube,
              srcMobile: bassCube_mob,
            },
            bassman: {
              alt: 'Jansen Bassman 25',
              caption: 'Classic New Zealand made solid state amp',
              name: 'Jansen Bassman 25',
              src: bassman,
              srcMobile: bassman_mob,
            },
          },
          name: 'Amplification',
        },
        basses: {
          items: {
            bass1: {
              alt: 'Hayman Bass',
              caption: '1974 Hayman with custom transistor preamp',
              name: 'Hayman 40/40',
              src: hayman,
              srcMobile: hayman_mob,
            },
            bass2: {
              alt: 'Balalaika Bass',
              caption: 'Balalaika Bass handmade in Te Pahu by Halliday',
              name: 'Russian Style Balalaika Bass',
              src: balalaika,
              srcMobile: balalaika_mob,
            },
            otherbasses: {
              alt: 'Other Basses',
              caption: 'Including handmade Halliday J bass',
              name: 'Other Basses',
              src: otherBasses,
              srcMobile: otherBasses_mob,
            },
            uprightbass: {
              alt: 'Upright bass',
              caption: 'Czechoslovakian upright ',
              name: 'Upright Bass',
              src: upright,
              srcMobile: upright_mob,
            },
          },
          name: 'Bass Guitars',
        },
        drums: {
          items: {
            rogers: {
              alt: 'Rogers drum kit',
              caption:
                '1964 Rogers Kit & Ludwig Acrolite Snare & Paiste, Zildjian and Istanbul cymbals',
              name: 'Rogers',
              src: rogers,
              srcMobile: rogers_mob,
            },
          },
          name: 'drums',
        },
        guitars: {
          items: {
            acousticguitars: {
              alt: 'Acoustic and Ukulele',
              caption: 'Handmade Halliday classical guitar and Captain ukulele',
              name: 'Various Acoustic Guitars',
              src: acoustics,
              srcMobile: acoustics_mob,
            },
            guitar1: {
              alt: 'Ibanez and Halliday',
              caption: 'Ibanez Recording Les Paul and handmade Halliday ES-175',
              name: 'Ibanez and Halliday',
              src: ibanezHalliday,
              srcMobile: ibanezHalliday_mob,
            },
            guitar2: {
              alt: 'Electric Guitars',
              caption: 'From left: Les Paul, Strat, Jaguar, Tele, Fretless Hollow Bass',
              name: 'Electric Guitars',
              src: electrics,
              srcMobile: electrics_mob,
            },
          },
          name: 'Guitars',
        },
        keys: {
          items: {
            keys1: {
              alt: 'Piano',
              caption: 'Danemann upright piano',
              name: 'Piano',
              src: piano,
              srcMobile: piano_mob,
            },
          },
          name: 'Keys',
        },
      },
      order: 4,
    },
  ],
]



// WEBPACK FOOTER //
// /opt/build/repo/src/data/gallery.js